import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

export interface SupportRecordPayload {
  client_id: string | number;
  support_type: string;
  lead_id?: string | number;
  customer_id?: string;
  customer_name?: string;
  subject?: string;
  agent_name?: string;
  user_id?: string | number;
  reference_id?: string;
  metadata?: Record<string, unknown>;
}

export interface SupportRecord {
  id: number;
  client_id: number;
  lead_id: number;
  customer_id: string;
  customer_name?: string | null;
  support_type: string;
  subject?: string | null;
  agent_name?: string | null;
  user_id?: string | null;
  reference_id?: string | null;
  metadata?: Record<string, unknown> | null;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class SupportRecordService {
  constructor(private api: ApiService) {}

  createSupportRecord(payload: SupportRecordPayload): Observable<{
    ok?: boolean;
    created?: boolean;
    record?: SupportRecord;
    message?: string;
  }> {
    return this.api.post(environment.createSupportRecord, payload);
  }

  getSupportRecords(payload: {
    client_id: string | number;
    lead_id?: string | number;
    customer_id?: string;
    support_type?: string;
    page?: number;
    limit?: number;
  }): Observable<{
    ok?: boolean;
    page?: number;
    limit?: number;
    total?: number;
    records?: SupportRecord[];
    message?: string;
  }> {
    return this.api.post(environment.getSupportRecords, payload);
  }
}
